import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

async function fetchSuggestedContactNames(spaceId: string) {
  const { data, error } = await apiClient
    .from('subject_action_contact_name_suggestions')
    .select('*')
    .eq('space_id', spaceId)
    .limit(20);

  if (error) {
    throw error;
  }

  return data;
}

export function useGetSuggestedContactNames() {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.getSuggestedContactNames(currentSpace?.id ?? ''),
    queryFn: () => fetchSuggestedContactNames(currentSpace!.id),
    enabled: !!currentSpace?.id,
    staleTime: _3_DAYS,
  });
}
